import React, { useState } from 'react';
import { URL } from "../../constants/constant";
import SideBar from "../../components/SideBar/SideBar";
import { TextField, MenuItem, Button, Select, FormControl, InputLabel, Snackbar } from "@mui/material";
import "./UserOnboarding.css";
import axios from 'axios';

const UserOnboarding = () => {

    const [userData, setUserData] = useState({
        firstName: '',
        lastName: '',
        emailId: '',
        employeeId: '',
        phoneNumber: '',
        gender: '',
        roleType: '',
        userDomain: '',
        role: 'QCuser',
        isTechTeam: 0
    });
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');

    const loggedInUser = JSON.parse(localStorage.getItem("loggedInUserDetails"));

    const userTypes = [
        { value: 2, label: "Admin" },
        { value: 3, label: "Data Entry and QC User" },
        { value: 4, label: "Data Entry User" },
        { value: 5, label: "QC User" },
        { value: 6, label: "Doctor Entry User" }
    ];

    const userCategories = [
        { value: "Corporate", label: "Corporate" },
        { value: "Insurance", label: "Insurance" }
    ];

    const handleChange = (event) => {
        const { name, value } = event.target;
        setUserData({
            ...userData,
            [name]: value
        });
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        if (userData.roleType === 2) {
            userData.role = 'Admin';
        }
        console.log('User Data:', userData);
        axios.post(URL.demystify_url + 'auth/createUserV2', userData)
            .then(response => {
                if (response.status !== 200) {
                    setSnackbarMessage('Error: Unable to create user.');
                    setSnackbarOpen(true);
                } else {
                    setSnackbarMessage('User created successfully.');
                    setSnackbarOpen(true);
                }
            })
            .catch(error => {
                setSnackbarMessage('Error: ' + (JSON.stringify(error.response)));
                setSnackbarOpen(true);
            });
    };

    return (
        <div className='grid-container-user-onboarding'>
            <div className='grid-sidebar'>
                <SideBar isTechTeam={loggedInUser.isTechTeam} />
            </div>
            <div className='grid-user-onboarding'>
                <div className="user-onboarding-title">
                    <h1>User Onboarding</h1>
                </div>
                <form onSubmit={handleSubmit} className="user-details">
                    <div className='user-details-div'>
                        <TextField
                            label="First Name"
                            variant="outlined"
                            name="firstName"
                            value={userData.firstName}
                            onChange={handleChange}
                            required
                            className='user-details-field'
                        />
                    </div>
                    <div className='user-details-div'>
                        <TextField
                            label="Last Name"
                            variant="outlined"
                            name="lastName"
                            value={userData.lastName}
                            onChange={handleChange}
                            required
                            className='user-details-field'
                        />
                    </div>
                    <div className='user-details-div'>
                        <TextField
                            label="Email ID"
                            type="email"
                            variant="outlined"
                            name="emailId"
                            value={userData.emailId}
                            onChange={handleChange}
                            required
                            className='user-details-field'
                        />
                    </div>
                    <div className='user-details-div'>
                        <TextField
                            label="Employee ID"
                            variant="outlined"
                            name="employeeId"
                            value={userData.employeeId}
                            onChange={handleChange}
                            required
                            className='user-details-field'
                        />
                    </div>
                    <div className='user-details-div'>
                        <TextField
                            label="Phone Number"
                            type="tel"
                            variant="outlined"
                            name="phoneNumber"
                            value={userData.phoneNumber}
                            onChange={handleChange}
                            required
                            className='user-details-field'
                        />
                    </div>
                    <div className='user-details-div'>
                        <FormControl className='user-details-field'>
                            <InputLabel>Gender</InputLabel>
                            <Select
                                name="gender"
                                value={userData.gender}
                                label="Gender"
                                onChange={handleChange}
                                required
                                margin='normal'
                            >
                                <MenuItem value="Male">Male</MenuItem>
                                <MenuItem value="Female">Female</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                    <div className='user-details-div'>
                        <FormControl className='user-details-field'>
                            <InputLabel>User Type</InputLabel>
                            <Select
                                name="roleType"
                                value={userData.roleType}
                                label="User Type"
                                onChange={handleChange}
                                required
                                margin='normal'
                            >
                                {userTypes.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </div>
                    <div className='user-details-div'>
                        <FormControl className='user-details-field'>
                            <InputLabel>User Domain</InputLabel>
                            <Select
                                name="userDomain"
                                value={userData.userDomain}
                                label="User Domain"
                                onChange={handleChange}
                                required
                                margin='normal'
                            >
                                {userCategories.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </div>
                    <Button type="submit" variant="contained">Submit</Button>
                </form>
                <Snackbar
                    open={snackbarOpen}
                    autoHideDuration={6000}
                    onClose={() => setSnackbarOpen(false)}
                    message={snackbarMessage}
                />
            </div>
        </div>
    );
};

export default UserOnboarding;